import React, { useState } from "react";
import TaskView from "../common/TaskView";
import { AcousticTask, AcousticTaskDefinition } from "../common/models";
import { randomUUID } from "../../../utils";
import { RandomItemGenerationTask } from "./RandomItemGenerationTask";
import { useApiService } from "../../../../services/ApiServiceProvider";
import { useStorage } from "../../../../services/StorageProvider";

const Definition: AcousticTaskDefinition = {
  name: 'Random Item Generation (v2)',
  title: 'Random Item Generation',
  description: '',
  cohort: 'neuro',
  type: 'acoustic-task',
  estimatedCompletionTime: '2:00',
  subTaskDefinitions: [
    {
      name: `Random Item Generation (v2)`,
      instructions: '',
      title: '',
      content: null,
      profileName: 'speech',
      stopwatchSeconds: 60,
    }
  ],
};
export const RandomItemGenerationDefinition = Definition;

export const RandomItemGeneration =  ({onCompletion}: {onCompletion: () => void}) => {
  const apiService = useApiService();
  const { storage } = useStorage();
  const session: any = storage.session;
  const [isRecording, setIsRecording] = useState(false);
  const [category, setCategory] = useState<string>('');
  const [task, _] = useState<AcousticTask>(() => {
    return ({
      ...Definition,
      id: randomUUID(),
      startedAt: new Date().toISOString(),
      completedAt: null,
      status: 'pending',
      subTasks: Definition.subTaskDefinitions.map((definition) => ({
        ...definition,
        id: randomUUID(),
      }))
    });
  });

  const handleOnCompletion = async () => {
    console.log("Audio task completed", task.title);
    onCompletion();
  }

  const handleCreateQuestionnaire = async () => {
    const startAt = task.startedAt || new Date().toISOString();
    const completedAt = task.completedAt || new Date().toISOString();
    const payload = {
      sessionId: session.id,
      subjectId: session.subjectId,
      startedAt: startAt,
      completedAt: completedAt,
      acousticTaskId: task.id,
      category: category
    };

    await apiService.createQuestionnaire('/api/randomItemGenerationQuestionnaires', payload);
  };

  const handleIsRecordingChange = (isRecording: boolean) => {
    setIsRecording(isRecording);
  };

  const handleCategoryChange = (category: string) => {
    setCategory(category);
  };

  return (
    <div>
      <TaskView
        task={task}
        onCompletion={handleOnCompletion}
        onIsRecordingChange={handleIsRecordingChange}
        content={<RandomItemGenerationTask
          onCategoryChange={handleCategoryChange}
          isRecording={isRecording}
          cohort="neuro"/>}
        createQuestionnaire={handleCreateQuestionnaire}
      />
    </div>
  );
};


